<template>
    <LoadingAspn type="news-1" v-if="newsPagination.isLoading"></LoadingAspn>
    <div v-show="!newsPagination.isLoading" class="w-100">
        <NoData v-if="news.length === 0" />
        <div v-else class="news-container">
            <div v-if="!isMobile">
                <router-link
                    :to="{
                        name: 'newsDetail',
                        params: {
                            title: news[0].urlName,
                            id: news[0].id,
                            currentSportType: news[0].sportTypePath,
                        },
                    }"
                    tag="div"
                    class="news-item first"
                    v-if="news[0]"
                >
                    <div class="news-image">
                        <img
                            class="news-image--coverImg"
                            :src="`${s3ImgUrl}/${news[0].coverImage}`"
                        />
                    </div>
                    <div class="news-content">
                        <div class="news-title">
                            {{ news[0].title }}
                        </div>
                        <div class="news-date">
                            {{ news[0].publishedOn }}
                        </div>
                    </div>
                </router-link>
                <div class="news-list">
                    <template v-for="(item, index) in news" :key="index">
                        <router-link
                            :to="{
                                name: 'newsDetail',
                                params: {
                                    title: item.urlName,
                                    id: item.id,
                                    currentSportType: item.sportTypePath,
                                },
                            }"
                            tag="div"
                            class="news-item"
                            v-if="index > 0"
                        >
                            <div
                                class="ratio-169-container"
                                v-if="isMobile"
                            ></div>
                            <div class="news-image ratio-169-content">
                                <img
                                    class="news-image--coverImg"
                                    :src="`${s3ImgUrl}/${item.coverImage}`"
                                />
                            </div>
                            <div class="news-content">
                                <div class="news-title">
                                    {{ item.title }}
                                </div>
                                <div class="news-date">
                                    {{ item.publishedOn }}
                                </div>
                            </div>
                        </router-link>
                    </template>
                </div>
            </div>

            <template v-else>
                <div class="news-list">
                    <template v-for="(item, index) in news" :key="index">
                        <router-link
                            :to="{
                                name: 'newsDetail',
                                params: {
                                    title: item.urlName,
                                    id: item.id,
                                    currentSportType: item.sportTypePath,
                                },
                            }"
                            tag="div"
                            class="news-item"
                        >
                            <div class="news-image">
                                <img
                                    class="news-image--coverImg"
                                    :src="`${s3ImgUrl}/${item.coverImage}`"
                                />
                            </div>
                            <div class="news-content">
                                <div class="news-title">
                                    {{ item.title }}
                                </div>
                                <div class="news-date">
                                    {{ item.publishedOn }}
                                </div>
                            </div>
                        </router-link>
                    </template>

                    <div class="news-mobile-ads-box">
                        <img
                            src="../../../../../static/images/icons/aspn_icon/player/news_ads_mobile_1.png"
                            class="news-mobile-ads"
                        />
                    </div>

                    <div class="news-mobile-ads-box">
                        <img
                            src="../../../../../static/images/icons/aspn_icon/player/news_ads_mobile_2.png"
                            class="news-mobile-ads"
                        />
                    </div>
                </div>
            </template>

            <div class="display-flex-align-fs">
                <van-loading v-if="newsPagination.isLoading" />
            </div>
            <!-- <div v-if="!newsPagination.isLoading" class="skeleton-child h-100"></div> -->

            <div
                class="load-more"
                v-if="!newsPagination.lastPage"
                @click="loadMore()"
            >
                {{ $t("SEE_MORE") }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import config from "@/js/config.js";
import moment from "moment";
export default {
    name: "teamNews",
    data() {
        return {
            s3ImgUrl: config.s3ImgUrl,
            news: [],
            // league news
            newsPagination: {
                pageNo: 1,
                sportType: "SOCCER",
                pageSize: 10,
                lastPage: false,
                isLoading: false,
            },
        };
    },
    computed: {
        ...mapGetters(["isMobile"]),
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions(["getNewsListByPlayer"]),
        init() {
            this.getNewsListByPlayerData();
        },
        async getNewsListByPlayerData(loadMore = false) {
            this.newsPagination.isLoading = true;
            let params = {
                playerIds: this.$route.params.player,
                sportType: "SOCCER",
                pageNo: this.newsPagination.pageNo,
                pageSize: this.newsPagination.pageSize,
            };
            const result = await this.getNewsListByPlayer(params);
            if (result.errorCode === 0) {
                if (!loadMore) {
                    this.news = this.generateNewsList(result.result.content);
                } else {
                    const list = this.generateNewsList(result.result.content);
                    this.news = this.news.concat(list);
                }

                if (result.result.last) {
                    this.newsPagination.lastPage = true;
                }
            }
            this.newsPagination.isLoading = false;
        },
        generateNewsList(data) {
            for (let x = 0; x < data.length; x++) {
                let convertedDate;
                let A = moment(data[x].publishedOn);
                let B = moment();
                let diffDays = A.diff(B, "days");

                if (diffDays > 0) {
                    convertedDate = moment(data[x].publishedOn).fromNow();
                } else {
                    convertedDate = moment(data[x].publishedOn).format(
                        "dddd D MMM YYYY"
                    );
                }
                let theNewsData = data[x];
                if (theNewsData.sportType == "SOCCER") {
                    theNewsData.sportTypePath = "football";
                } else {
                    theNewsData.sportTypePath =
                        theNewsData.sportType.toLowerCase();
                }
                data[x].urlName = data[x].title
                    .toLowerCase()
                    .replace(/\s/g, "-");
                data[x].publishedOn = moment(data[x].publishedOn).fromNow(); //moment("2019-09-10T07:53:06.000+00:00").fromNow(); //
            }
            return data;
        },
        loadMore() {
            this.newsPagination.pageNo += 1;
            this.getNewsListByTeamData(true);
        },
    },
};
</script>

<style scoped>
.news-container {
    padding: 24px;
    box-sizing: border-box;
    background-color: var(--color-background-default-secondary);
    border-radius: 16px;
}
.news-list {
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(4, calc(25% - 18px));
}
</style>

<style scoped src="../../../../assets/css/news/index.css"></style>
